<template>
  <div class="print-resident-modern">
    <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
      <ErrorsMessages :errors="errors" />

      <div v-show="errors.length == 0" class="print-container">
        <!-- Print Button -->
        <div class="print-actions no-print">
          <v-btn class="btn-print-modern" @click="printOut">
            <i class="fas fa-print mr-2"></i>
            IMPRIMIR RELATÓRIO
          </v-btn>
        </div>

        <!-- Print Content -->
        <div class="print-content" v-if="resident">
          <!-- Main Container -->
          <div class="attendance-sheet">
            <!-- Left Column -->
            <div class="left-column">
              <!-- Logo and Institution Info -->
              <div class="institution-section">
                <img
                  v-if="rest_home_logo_url"
                  class="institution-logo"
                  :src="rest_home_logo_url"
                  alt="Logo da Instituição"
                />
                <div class="institution-info">
                  <h3 class="institution-name">{{ rest_home_name }}</h3>
                  <p class="institution-address">
                    {{ resident.rest_home.address }},
                    {{ resident.rest_home.num_address }} -
                    {{ resident.rest_home.neighborhood }},
                    {{ resident.rest_home.city }}/{{
                      resident.rest_home.uf_name
                    }}
                  </p>
                </div>
              </div>

              <!-- Resident Photo -->
              <div class="resident-photo-section">
                <img
                  :src="resident.photo_url || require('../../assets/user.png')"
                  class="resident-photo"
                  alt="Foto do Residente"
                />
              </div>

              <!-- Side Information -->
              <!-- <div class="side-info-section">
                <div class="side-info-item">
                  <h4>PLANO DE SAÚDE</h4>
                  <p>SUS</p>
                </div>
              </div> -->
            </div>

            <!-- Right Column -->
            <div class="right-column">
              <!-- Header Title -->
              <div class="header-title">
                <h2>INFORMAÇÕES - {{ resident.name }}</h2>
              </div>

              <!-- Personal Information Grid -->
              <div class="info-grid-compact">
                <!-- ===================== GERAL ===================== -->
                <template v-if="showField('general')">
                  <div class="info-row" v-if="showField('general', 'name')">
                    <span class="info-label">Nome</span>
                    <span class="info-value">{{ resident.name }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'gender_id')"
                  >
                    <span class="info-label">Sexo</span>
                    <span class="info-value">{{ resident.gender_name }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'date_of_birth')"
                  >
                    <span class="info-label">Data nasc. / Idade</span>
                    <span class="info-value">
                      {{ formatDate(resident.date_of_birth, false) }} /
                      {{ getAge(resident.date_of_birth) }} anos
                    </span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'status_type_id')"
                  >
                    <span class="info-label">Status</span>
                    <span class="info-value">{{
                      resident.status_type_name || "--"
                    }}</span>
                  </div>
                  <div class="info-row" v-if="showField('general', 'phone')">
                    <span class="info-label">Telefone</span>
                    <span class="info-value">{{ resident.phone || "--" }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'degree_of_dependence_id')"
                  >
                    <span class="info-label">Grau de Dependência</span>
                    <span class="info-value">{{
                      resident.degree_of_dependence_name || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'type_of_food')"
                  >
                    <span class="info-label">Tipo de Alimentação</span>
                    <span class="info-value">{{
                      resident.type_of_food || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'pathology')"
                  >
                    <span class="info-label">Patologia</span>
                    <span class="info-value">{{
                      resident.pathology || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'miscellaneous_allergies')"
                  >
                    <span class="info-label">Alergias Diversas</span>
                    <span class="info-value">{{
                      resident.miscellaneous_allergies || "--"
                    }}</span>
                  </div>
                  <div class="info-row" v-if="showField('general', 'nickname')">
                    <span class="info-label">Apelido</span>
                    <span class="info-value">{{
                      resident.nickname || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'naturalness')"
                  >
                    <span class="info-label">Naturalidade</span>
                    <span class="info-value">{{
                      resident.naturalness || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'marital_status_id')"
                  >
                    <span class="info-label">Estado Civil</span>
                    <span class="info-value">
                      {{
                        resident.marital_status && resident.marital_status.name
                          ? resident.marital_status.name
                          : "--"
                      }}
                    </span>
                  </div>
                  <div class="info-row" v-if="showField('general', 'religion')">
                    <span class="info-label">Religião</span>
                    <span class="info-value">{{
                      resident.religion || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'profession')"
                  >
                    <span class="info-label">Profissão</span>
                    <span class="info-value">{{
                      resident.profession || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'schooling')"
                  >
                    <span class="info-label">Escolaridade</span>
                    <span class="info-value">{{
                      resident.schooling || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'fathers_name')"
                  >
                    <span class="info-label">Pai</span>
                    <span class="info-value">{{
                      resident.fathers_name || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('general', 'mothers_name')"
                  >
                    <span class="info-label">Mãe</span>
                    <span class="info-value">{{
                      resident.mothers_name || "--"
                    }}</span>
                  </div>
                  <div class="info-row" v-if="showField('general', 'spouse')">
                    <span class="info-label">Cônjuge</span>
                    <span class="info-value">{{
                      resident.spouse || "--"
                    }}</span>
                  </div>
                  <div class="info-row" v-if="showField('general', 'comments')">
                    <span class="info-label">Observações</span>
                    <span class="info-value">{{
                      resident.comments || "--"
                    }}</span>
                  </div>
                  <div class="info-row" v-if="showField('general', 'weight')">
                    <span class="info-label">Peso</span>
                    <span class="info-value">{{
                      resident.weight || "--"
                    }}</span>
                  </div>
                  <div class="info-row" v-if="showField('general', 'height')">
                    <span class="info-label">Altura</span>
                    <span class="info-value">{{
                      resident.height || "--"
                    }}</span>
                  </div>
                  <div class="info-row" v-if="showField('general', 'imc')">
                    <span class="info-label">IMC</span>
                    <span class="info-value">
                      ({{ resident.imc.imc }}) {{ resident.imc.classificacao }}
                    </span>
                  </div>
                </template>

                <!-- ===================== DOCUMENTOS ===================== -->
                <template v-if="showField('docs')">
                  <div class="info-row" v-if="showField('docs', 'rg')">
                    <span class="info-label">RG nº</span>
                    <span class="info-value">{{ resident.rg || "--" }}</span>
                  </div>
                  <div class="info-row" v-if="showField('docs', 'cpf')">
                    <span class="info-label">CPF nº</span>
                    <span class="info-value">{{ resident.cpf || "--" }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('docs', 'issuing_body')"
                  >
                    <span class="info-label">Órgão Expedidor</span>
                    <span class="info-value">{{
                      resident.issuing_body || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('docs', 'date_of_issue')"
                  >
                    <span class="info-label">Data de Emissão</span>
                    <span class="info-value">
                      {{
                        resident.date_of_issue
                          ? formatDate(resident.date_of_issue, false)
                          : "--"
                      }}
                    </span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('docs', 'SUS_card_number')"
                  >
                    <span class="info-label">Cartão SUS</span>
                    <span class="info-value">{{
                      resident.SUS_card_number || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('docs', 'INSS_benefit_number')"
                  >
                    <span class="info-label">Benefício INSS nº</span>
                    <span class="info-value">{{
                      resident.INSS_benefit_number || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('docs', 'type_of_INSS_benefit')"
                  >
                    <span class="info-label">Tipo Benefício INSS</span>
                    <span class="info-value">{{
                      resident.type_of_INSS_benefit || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('docs', 'inss_benefit_status_id')"
                  >
                    <span class="info-label">Situação INSS</span>
                    <span class="info-value">{{
                      resident.inss_benefit_status_name || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('docs', 'INSS_benefit_amount')"
                  >
                    <span class="info-label">Valor Benefício INSS</span>
                    <span class="info-value">
                      R$
                      {{
                        resident.INSS_benefit_amount
                          ? formatValueOnKeyUp(
                              String(resident.INSS_benefit_amount)
                            )
                          : "--"
                      }}
                    </span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('docs', 'INSS_update_date')"
                  >
                    <span class="info-label">Atualização INSS</span>
                    <span class="info-value">
                      {{
                        resident.INSS_update_date
                          ? formatDate(resident.INSS_update_date, false)
                          : "--"
                      }}
                    </span>
                  </div>
                </template>

                <!-- ===================== ENDEREÇO ===================== -->
                <template v-if="showField('address')">
                  <div
                    class="info-row full-width"
                    v-if="showField('address', 'cep')"
                  >
                    <span class="info-label">CEP</span>
                    <span class="info-value">{{ resident.cep || "--" }}</span>
                  </div>
                  <div
                    class="info-row full-width"
                    v-if="showField('address', 'address')"
                  >
                    <span class="info-label">Endereço</span>
                    <span class="info-value">{{
                      resident.address || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('address', 'number_address')"
                  >
                    <span class="info-label">Número</span>
                    <span class="info-value">{{
                      resident.number_address || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('address', 'neighborhood')"
                  >
                    <span class="info-label">Bairro</span>
                    <span class="info-value">{{
                      resident.neighborhood || "--"
                    }}</span>
                  </div>
                  <div class="info-row" v-if="showField('address', 'city')">
                    <span class="info-label">Cidade</span>
                    <span class="info-value">{{ resident.city || "--" }}</span>
                  </div>
                  <div class="info-row" v-if="showField('address', 'uf_id')">
                    <span class="info-label">Estado</span>
                    <span class="info-value">
                      {{
                        resident.uf && resident.uf.name
                          ? resident.uf.name
                          : "--"
                      }}
                    </span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('address', 'complement')"
                  >
                    <span class="info-label">Complemento</span>
                    <span class="info-value">{{
                      resident.complement || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row"
                    v-if="showField('address', 'reference')"
                  >
                    <span class="info-label">Referência</span>
                    <span class="info-value">{{
                      resident.reference || "--"
                    }}</span>
                  </div>
                </template>

                <!-- ===================== HOSPEDAGEM ===================== -->
                <template v-if="showField('hosting')">
                  <div
                    class="info-row full-width"
                    v-if="showField('hosting', 'type_of_hosting_id')"
                  >
                    <span class="info-label">Tipo de Hospedagem</span>
                    <span class="info-value">{{
                      resident.type_of_hosting_name || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row full-width"
                    v-if="showField('hosting', 'date_of_reception')"
                  >
                    <span class="info-label">Data da Hospedagem</span>
                    <span class="info-value">
                      {{
                        resident.date_of_reception
                          ? formatDate(resident.date_of_reception, false)
                          : "--"
                      }}
                    </span>
                  </div>
                  <div
                    class="info-row full-width"
                    v-if="showField('hosting', 'bed_id')"
                  >
                    <span class="info-label">Leito</span>
                    <span class="info-value">
                      <template v-if="resident.bed">
                        Nº {{ resident.bed.number }} - Andar
                        {{ resident.bed.walk }} - Quarto
                        {{ resident.bed.bedroom }} - (ALA/Setor)
                        {{ resident.bed.ward_or_sector }}
                      </template>
                      <template v-else>--</template>
                    </span>
                  </div>
                  <div
                    class="info-row full-width"
                    v-if="showField('hosting', 'income_monthly_fee')"
                  >
                    <span class="info-label">Mensalidade</span>
                    <span class="info-value">
                      {{
                        resident.income_monthly_fee
                          ? formatPrice(resident.income_monthly_fee)
                          : "--"
                      }}
                    </span>
                  </div>
                  <div
                    class="info-row full-width"
                    v-if="showField('hosting', 'reason_for_the_reception')"
                  >
                    <span class="info-label">Motivo da Hospedagem</span>
                    <span class="info-value">{{
                      resident.reason_for_the_reception || "--"
                    }}</span>
                  </div>
                  <div
                    class="info-row full-width"
                    v-if="showField('hosting', 'date_end_contract')"
                  >
                    <span class="info-label">Vencimento do Contrato</span>
                    <span class="info-value">
                      {{
                        resident.date_end_contract
                          ? formatDate(resident.date_end_contract, false)
                          : "--"
                      }}
                    </span>
                  </div>
                </template>

                <!-- ===================== ENCERRAMENTO ===================== -->
                <div
                  class="info-row full-width"
                  v-if="
                    showField('contract_end') && resident.date_of_the_withdrawal
                  "
                >
                  <span class="info-label">Encerramento</span>
                  <span class="info-value">
                    {{ formatDate(resident.date_of_the_withdrawal, false) }} /
                    Motivo: {{ resident.reason_for_the_withdrawal }}
                    {{
                      resident.other_reasons
                        ? ": " + resident.other_reasons
                        : ""
                    }}
                  </span>
                </div>

                <!-- ===================== FAMILIARES ===================== -->
                <template
                  v-if="
                    showField('customer') &&
                    resident.customer_has_resident &&
                    resident.customer_has_resident.length > 0
                  "
                >
                  <div
                    class="info-row"
                    v-for="(item, key) in resident.customer_has_resident"
                    :key="'fam-' + key"
                  >
                    <span class="info-label">Familiar</span>
                    <div>
                      <span class="info-value">{{ item.name }}</span>
                      <span
                        class="info-value"
                        v-if="item.responsible_for_payment == 1"
                      >
                        Responsável pelo pagamento
                      </span>
                      <span
                        class="info-value"
                        v-if="item.responsible_for_contract == 1"
                      >
                        Responsável pelo contrato
                      </span>
                    </div>
                  </div>
                </template>

                <!-- ===================== CONVÊNIOS ===================== -->
                <template
                  v-if="
                    showField('agreement') &&
                    resident.agreement &&
                    resident.agreement.length > 0
                  "
                >
                  <div
                    class="info-row"
                    v-for="(item, key) in resident.agreement"
                    :key="'conv-' + key"
                  >
                    <span class="info-label">Convênio</span>
                    <div class="d-flex flex-wrap">
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'type_of_agreement_id') &&
                          item.type_of_agreement_name
                        "
                      >
                        Tipo: {{ item.type_of_agreement_name }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'covenant_name') &&
                          item.covenant_name
                        "
                      >
                        Nome: {{ item.covenant_name }}
                      </span>
                      <span
                        class="info-value"
                        v-if="showField('agreement', 'number') && item.number"
                      >
                        Nº Carteirinha: {{ item.number }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'type_plan_name') &&
                          item.type_plan_name
                        "
                      >
                        Plano: {{ item.type_plan_name }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'exchange_phone') &&
                          item.exchange_phone
                        "
                      >
                        Tel. central: {{ item.exchange_phone }}
                      </span>
                      <span
                        class="info-value"
                        v-if="showField('agreement', 'name') && item.name"
                      >
                        Titular: {{ item.name }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'type_of_customer_id') &&
                          item.type_of_customer_name
                        "
                      >
                        Parentesco: {{ item.type_of_customer_name }}
                      </span>
                      <span
                        class="info-value"
                        v-if="showField('agreement', 'phone') && item.phone"
                      >
                        Telefone: {{ item.phone }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'cell_phone') &&
                          item.cell_phone
                        "
                      >
                        Celular: {{ item.cell_phone }}
                      </span>
                      <span
                        class="info-value"
                        v-if="showField('agreement', 'note') && item.note"
                      >
                        Obs: {{ item.note }}
                      </span>
                      <span
                        class="info-value"
                        v-if="showField('agreement', 'cep') && item.cep"
                      >
                        CEP: {{ item.cep }}
                      </span>
                      <span
                        class="info-value"
                        v-if="showField('agreement', 'address') && item.address"
                      >
                        Endereço: {{ item.address }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'number_address') &&
                          item.number_address
                        "
                      >
                        Nº: {{ item.number_address }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'neighborhood') &&
                          item.neighborhood
                        "
                      >
                        Bairro: {{ item.neighborhood }}
                      </span>
                      <span
                        class="info-value"
                        v-if="showField('agreement', 'city') && item.city"
                      >
                        Cidade: {{ item.city }}
                      </span>
                      <span
                        class="info-value"
                        v-if="showField('agreement', 'uf_id') && item.uf"
                      >
                        Estado: {{ item.uf }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'reference') && item.reference
                        "
                      >
                        Referência: {{ item.reference }}
                      </span>
                      <span
                        class="info-value"
                        v-if="
                          showField('agreement', 'complement') &&
                          item.complement
                        "
                      >
                        Complemento: {{ item.complement }}
                      </span>
                    </div>
                  </div>
                </template>
              </div>

              <!-- Vital Signs Table -->
              <div
                class="section-box informations-table-section"
                v-if="showField('vital_signs')"
              >
                <h3 class="section-title-inline m-0">SINAIS VITAIS</h3>
                <table class="informations-table-table">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Descrição</th>
                      <th>Observação</th>
                      <th>Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-show="
                        resident.vital_signs && resident.vital_signs.length > 0
                      "
                      v-for="vital_sign in resident.vital_signs"
                      :key="vital_sign.id"
                    >
                      <td>{{ vital_sign.type }}</td>
                      <td>
                        {{
                          vital_sign.type != "DOR" ? vital_sign.description : ""
                        }}
                        {{
                          vital_sign.type == "DOR"
                            ? `(${handleDescriptionAche(
                                vital_sign.description
                              )})`
                            : vital_sign.abbreviation
                        }}
                      </td>
                      <td>{{ vital_sign.note ? vital_sign.node : "--" }}</td>
                      <td>
                        {{ formatDate(vital_sign.created_at) }}
                      </td>
                    </tr>
                    <tr
                      v-show="
                        !resident.vital_signs ||
                        resident.vital_signs.length == 0
                      "
                      v-for="i in 1"
                      :key="i"
                    >
                      <td colspan="100" class="text-center">--</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Medications Section -->
              <div
                class="section-box informations-table-section"
                v-if="showField('prescription')"
              >
                <h3 class="section-title-inline m-0">
                  MEDICAMENTOS PRECRIÇÃO ATUAL
                </h3>
                <table class="informations-table-table">
                  <thead>
                    <tr>
                      <th>Medicamento</th>
                      <th>Horário</th>
                      <th>Qtd.</th>
                      <th>Frequência</th>
                      <th>Repetição</th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-show="
                        resident.medications && resident.medications.length > 0
                      "
                      v-for="med in resident.medications"
                      :key="med.id"
                    >
                      <td>
                        {{ med.name }}

                        <p
                          class="m-0"
                          v-if="
                            med.group_prescription_medicine_type ==
                            'LONGO_PRAZO'
                          "
                        >
                          <small><strong>(LONGO PRAZO)</strong></small>
                        </p>
                      </td>
                      <td>
                        <span
                          v-for="time in med.times"
                          :key="`${med.id}-${time.id}`"
                          v-show="med.frequency != 'EVENTUAL'"
                        >
                          {{ time.time }} /
                        </span>
                        <span v-show="med.frequency == 'EVENTUAL'">
                          EVENTUAL
                        </span>
                      </td>
                      <td>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            med.medicine_amount_of_times_type == 'DAY' ||
                            med.frequency == 'EVENTUAL'
                          "
                        >
                          {{
                            med.drops_quantity
                              ? `${med.drops_quantity} GOTA(S)`
                              : med.ui_quantity
                              ? `${med.ui_quantity} UI`
                              : med.quantity
                          }}
                          {{
                            med.drops_quantity
                              ? ""
                              : med.ui_quantity
                              ? ""
                              : `${med.unit_of_measurement_name} (S)`
                          }}
                        </p>
                      </td>
                      <td>
                        {{ handleFrequency(med.frequency) }}
                      </td>
                      <td>
                        {{ handleEvery(med.every, med.frequency) }}
                      </td>
                      <td>
                        <span v-if="med.frequency == 'SEMANAL'">
                          {{ med.dom && "DOM" }}
                          {{ med.seg && "SEG" }}
                          {{ med.ter && "TER" }}
                          {{ med.qua && "QUA" }}
                          {{ med.qui && "QUI" }}
                          {{ med.sex && "SEX" }}
                          {{ med.sab && "SAB" }}
                        </span>
                      </td>
                      <td>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="med.medicine_amount_of_times_name"
                        >
                          {{ med.medicine_amount_of_times_name }}
                        </p>
                      </td>
                      <td>
                        <div
                          v-if="med.medicine_amount_of_times_type == 'SHIFTS'"
                        >
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0"
                            >
                              <span>TURNO</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0 pl-0"
                            >
                              <span>QUANTIDADE</span>
                            </div>
                          </div>
                          <div class="row" v-if="med.dawn && med.dawn_quantity">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>MADRUGADA</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0 pl-0"
                            >
                              <span>
                                {{
                                  med.drops_dawn_quantity
                                    ? `${med.drops_dawn_quantity} GOTA(S)`
                                    : med.ui_dawn_quantity
                                    ? `${med.ui_dawn_quantity} UI`
                                    : med.dawn_quantity
                                }}
                                {{
                                  med.drops_dawn_quantity
                                    ? ""
                                    : med.ui_dawn_quantity
                                    ? ""
                                    : `${med.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="med.morning && med.morning_quantity"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>MANHÃ</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0 pl-0"
                            >
                              <span>
                                {{
                                  med.drops_morning_quantity
                                    ? `${med.drops_morning_quantity} GOTA(S)`
                                    : med.ui_morning_quantity
                                    ? `${med.ui_morning_quantity} UI`
                                    : med.morning_quantity
                                }}
                                {{
                                  med.drops_morning_quantity
                                    ? ""
                                    : med.ui_morning_quantity
                                    ? ""
                                    : `${med.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="med.afternoon && med.afternoon_quantity"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>TARDE</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>
                                {{
                                  med.drops_afternoon_quantity
                                    ? `${med.drops_afternoon_quantity} GOTA(S)`
                                    : med.ui_afternoon_quantity
                                    ? `${med.ui_afternoon_quantity} UI`
                                    : med.afternoon_quantity
                                }}
                                {{
                                  med.drops_afternoon_quantity
                                    ? ""
                                    : med.ui_afternoon_quantity
                                    ? ""
                                    : `${med.unit_of_measurement_abbreviation}(S)`
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="med.night && med.night_quantity"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>NOITE</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>
                                {{
                                  med.drops_night_quantity
                                    ? `${med.drops_night_quantity} GOTA(S)`
                                    : med.ui_night_quantity
                                    ? `${med.ui_night_quantity} UI`
                                    : med.night_quantity
                                }}
                                {{
                                  med.drops_night_quantity
                                    ? ""
                                    : med.ui_night_quantity
                                    ? ""
                                    : `${med.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="med.shift_5 && med.shift_5_quantity"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>5º</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>
                                {{
                                  med.drops_shift_5_quantity
                                    ? `${med.drops_shift_5_quantity} GOTA(S)`
                                    : med.ui_shift_5_quantity
                                    ? `${med.ui_shift_5_quantity} UI`
                                    : med.shift_5_quantity
                                }}
                                {{
                                  med.drops_shift_5_quantity
                                    ? ""
                                    : med.ui_shift_5_quantity
                                    ? ""
                                    : `${med.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="med.shift_6 && med.shift_6_quantity"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>6º</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>
                                {{
                                  med.drops_shift_6_quantity
                                    ? `${med.drops_shift_6_quantity} GOTA(S)`
                                    : med.ui_shift_6_quantity
                                    ? `${med.ui_shift_6_quantity} UI`
                                    : med.shift_6_quantity
                                }}
                                {{
                                  med.drops_shift_6_quantity
                                    ? ""
                                    : med.ui_shift_6_quantity
                                    ? ""
                                    : `${med.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="med.shift_7 && med.shift_7_quantity"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>7º</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>
                                {{
                                  med.drops_shift_7_quantity
                                    ? `${med.drops_shift_7_quantity} GOTA(S)`
                                    : med.ui_shift_7_quantity
                                    ? `${med.ui_shift_7_quantity} UI`
                                    : med.shift_7_quantity
                                }}
                                {{
                                  med.drops_shift_7_quantity
                                    ? ""
                                    : med.ui_shift_7_quantity
                                    ? ""
                                    : `${med.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="med.shift_8 && med.shift_8_quantity"
                          >
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>8º</span>
                            </div>
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                            >
                              <span>
                                {{
                                  med.drops_shift_8_quantity
                                    ? `${med.drops_shift_8_quantity} GOTA(S)`
                                    : med.ui_shift_8_quantity
                                    ? `${med.ui_shift_8_quantity} UI`
                                    : med.shift_8_quantity
                                }}
                                {{
                                  med.drops_shift_8_quantity
                                    ? ""
                                    : med.ui_shift_8_quantity
                                    ? ""
                                    : `${med.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr
                      v-show="
                        !resident.medications ||
                        resident.medications.length == 0
                      "
                      v-for="i in 1"
                      :key="i"
                    >
                      <td colspan="100" class="text-center">--</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import { getAge } from "../../lib/getAgeByDate";

import {
  formatDate,
  formatPrice,
  professionalClassCouncilValue,
  formatValueOnKeyUp,
} from "../../lib/format";

import routes from "../../routes";

import moment from "moment";

import { userData } from "../../lib/functions";

export default {
  name: "PrintResident",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      id: "",
      errors: [],
      rest_home_id: "",
      user: null,
      resident: null,
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: true,

      sections: {},
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    getAge,
    formatDate,
    formatPrice,
    professionalClassCouncilValue,
    formatValueOnKeyUp,

    showField(section, field) {
      const s = this.sections[section];
      if (!s) return false;
      if (s === true) return true;
      if (!field) return true;
      return s.includes(field);
    },

    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0 || !nivel) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },

    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },

    handleEvery(every, frequency) {
      if (frequency == "EVENTUAL") {
        return "EVENTUAL";
      }

      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },

    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      this.id = id;

      // Novo parser: "general:name,pathology|docs:cpf|address|hosting:bed_id"
      // Monta: { general: ['name','pathology'], docs: ['cpf'], address: true, hosting: ['bed_id'] }
      const rawSections = this.$route.query.sections || "";
      const sectionsMap = {};

      rawSections.split("|").forEach((chunk) => {
        if (!chunk) return;
        const [sectionKey, fieldsStr] = chunk.split(":");
        // Se não tem campos após ":", a seção inteira está ativa sem filtro
        sectionsMap[sectionKey] = fieldsStr ? fieldsStr.split(",") : true;
      });

      this.sections = sectionsMap;

      const { rest_home_id, user, logo, permissions } = userData();

      this.user = user;
      this.rest_home_id = rest_home_id;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;
      this.permissions = permissions;

      await this.get();
    },

    async get() {
      try {
        this.loading = true;
        const { id } = this;
        var params = { id };

        const response = await api.get("/rest-home/resident/print", { params });
        const { error, errors, resident } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.resident = resident;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    printOut: () => window.print(),
  },
};
</script>

<style scoped>
/* Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.print-resident-modern {
  background: #f5f5f5;
  padding: 20px;
  min-height: 100vh;
}

.loading-overlay {
  min-height: 100vh;
}

.print-container {
  max-width: 100%;
  margin: 0 auto;
}

/* Print Button */
.print-actions {
  text-align: center;
  margin-bottom: 24px;
}

.btn-print-modern {
  background: linear-gradient(135deg, #0f65b0 0%, #0a4d8a 100%);
  color: white;
  padding: 14px 32px;
  border-radius: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.3);
  transition: all 0.3s ease;
}

.btn-print-modern:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(15, 101, 176, 0.4);
}

/* Print Content */
.print-content {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

/* Main Layout */
.attendance-sheet {
  display: grid;
  grid-template-columns: 200px 1fr;
  /* min-height: 297mm; */
  border: 2px solid #333;
}

/* Left Column */
.left-column {
  background: #f8f9fa;
  border-right: 2px solid #333;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.institution-section {
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #ddd;
}

.institution-logo {
  max-width: 100px;
  max-height: 100px;
  margin-bottom: 12px;
}

.institution-name {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.3;
}

.institution-address {
  font-size: 11px;
  color: #666;
  line-height: 1.4;
}

.resident-photo-section {
  text-align: center;
}

.resident-photo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ddd;
}

.side-info-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.side-info-item h4 {
  font-size: 12px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
  text-transform: uppercase;
  border-bottom: 1px solid #333;
  padding-bottom: 4px;
}

.side-info-item p {
  font-size: 11px;
  color: #444;
  line-height: 1.4;
}

.professional-grid {
  display: grid;
  gap: 8px;
}

.professional-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.professional-item .label {
  font-size: 10px;
  font-weight: 600;
  color: #666;
}

.professional-item .value {
  font-size: 11px;
  color: #333;
}

/* Right Column */
.right-column {
  padding: 0;
}

.header-title {
  background: #fff;
  border-bottom: 2px solid #333;
  padding: 12px 20px;
  text-align: center;
}

.header-title h2 {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Info Grid Compact */
.info-grid-compact {
  padding: 2px 5px;
  display: grid;
  gap: 0;
}

.info-row {
  display: grid;
  grid-template-columns: 150px 1fr;
  border-bottom: 1px solid #ddd;
  align-items: center;
}

.info-row.full-width {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 11px;
  font-weight: 600;
  color: #333;
  padding: 4px 8px;
  background: #f8f9fa;
  border-right: 1px solid #ddd;
}

.info-value {
  font-size: 11px;
  color: #333;
  padding: 0px 12px;
}

/* Section Boxes */
.section-box {
  border-top: 2px solid #333;
  padding: 12px 20px;
}

.section-box-small {
  border-top: 1px solid #ddd;
  padding: 8px 20px;
}

.section-box-inline {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px;
  border-top: 1px solid #ddd;
}

.section-title-inline {
  font-size: 12px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
  text-transform: uppercase;
  display: inline-block;
  padding: 4px 0;
}

.risks-title {
  background: #ffe0e0;
  padding: 4px 12px;
  border-radius: 4px;
}

/* Tables */
.info-table,
.informations-table-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10px;
}

.info-table th,
.informations-table-table th {
  background: #f8f9fa;
  border: 1px solid #ddd;
  padding: 6px;
  font-weight: 600;
  text-align: center;
  color: #333;
}

.info-table td,
.informations-table-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
  color: #333;
}

.informations-table-table th {
  font-size: 10px;
}

.informations-table-table td {
  text-align: left;
  padding: 4px 8px;
}

/* Evolution Box */
.evolution-box {
  min-height: 120px;
}

.evolution-content {
  min-height: 100px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
}

/* Bottom Sections */
.bottom-sections {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.underline-space {
  flex: 1;
  border-bottom: 1px solid #333;
  margin-left: 12px;
}

/* Medications Section */
.informations-table-section {
  border-top: 2px solid #333;
}

.mt-2 {
  margin-top: 8px;
}

/* Print Styles */
@media print {
  .print-resident-modern {
    background: white !important;
    padding: 0 !important;
  }

  .no-print {
    display: none !important;
  }

  .print-content {
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .attendance-sheet {
    min-height: auto;
    page-break-inside: avoid;
  }

  body {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  .risks-title {
    background: #ffe0e0 !important;
  }
}

/* Responsive */
@media (max-width: 1024px) {
  .attendance-sheet {
    grid-template-columns: 1fr;
  }

  .left-column {
    border-right: none;
    border-bottom: 2px solid #333;
  }

  .resident-photo {
    width: 120px;
    height: 120px;
  }
}
</style>